import React, { useState } from 'react'

import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  CircularProgress
} from '@mui/material'
import { makeStyles } from '@mui/styles'

import { ErrorMessage, Field, Form, Formik } from 'formik'
import { Status } from '../../../../hooks/useFetchState'
import { useApi } from '../../../../hooks/useApi'
import * as Yup from 'yup'
import { ApiConfig } from '../../../../config/api'
import axios from 'axios'

interface PickingRouteAdminEditLpnProps {
  pickingRouteId: number
  lpn: string
  fetchDataGrid: () => void
  handleShowSnackbar: (msg: string | undefined, status: boolean) => void
}

interface CreateLPN {
  pickingRouteId: number
  LPN: string
}

export const validationSchema = Yup.object().shape({
  LPN: Yup.string()
    .transform((value) => (value === null ? '' : value))
    .trim()
    .min(1, 'Se requiere al menos un caracter')
    .required('LPN/Tote es obligatorio')
})

const createLPN = (body: CreateLPN) => {
  const url = new URL(
    `${ApiConfig.PickingRouteApi}/UpdateLPN/${body.pickingRouteId}`
  )
  return axios.put(url.toString(), { lpn: body.LPN })
}

export const PickingRouteAdminEditLpn: React.FC<
  PickingRouteAdminEditLpnProps
> = ({ pickingRouteId, lpn, fetchDataGrid, handleShowSnackbar }) => {
  const classes = useStyles()
  const [error, setError] = useState('')
  const [ok, setOk] = useState('')
  const { state, callApi } = useApi()

  const requestInsertLPN = async (dto: CreateLPN) => {
    setError('')
    setOk('')

    await callApi(createLPN(dto))
      .then(() => {
        handleShowSnackbar(
          `LPN/TOTE reasignado en Ruta N° ${pickingRouteId}`,
          true
        )
        fetchDataGrid()
      })
      .catch((data) => {
        setError(data)
      })
  }

  const handleSubmit = async (values: CreateLPN) => {
    await requestInsertLPN(values)
  }

  return (
    <Grid
      container
      spacing={3}
      direction='column'
      alignItems='center'
      justifyContent='space-between'
      style={{ marginTop: '0px', marginBottom: '0px' }}
    >
      <Typography>{'Asignar LPN/Tote'}</Typography>
      <Grid item xs={12}>
        <Formik
          initialValues={{
            LPN: lpn,
            pickingRouteId: pickingRouteId
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => new Promise(() => handleSubmit(values))}
        >
          {({ isValid }) => (
            <Form>
              <Box display='flex' alignItems='center' p={1} m={1}>
                <Field
                  fullWidth
                  as={TextField}
                  type='text'
                  name='LPN'
                  label='Ingresar LPN/Tote'
                  variant='outlined'
                  InputLabelProps={{
                    shrink: true
                  }}
                  autoFocus
                  autoComplete='off'
                />
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  style={{ marginLeft: 10 }}
                  disabled={!isValid || state.status === Status.Loading}
                  startIcon={
                    state.status === Status.Loading && (
                      <CircularProgress size={20} />
                    )
                  }
                >
                  {'>'}
                </Button>
              </Box>

              <ErrorMessage
                name='LPN'
                component='div'
                className={classes.errorMessage}
              />
              {error && (
                <Typography variant='body2' className={classes.errorMessage}>
                  {error}
                </Typography>
              )}

              {ok && (
                <Typography variant='body2' className={classes.okMessage}>
                  {ok}
                </Typography>
              )}
            </Form>
          )}
        </Formik>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles(() => ({
  errorMessage: {
    marginLeft: '15px',
    color: 'red'
  },
  okMessage: {
    marginLeft: '15px',
    color: 'green'
  }
}))
